function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_11",
  "data-name": "Ellipse 11",
  cx: 21,
  cy: 21,
  r: 21,
  fill: "#eeeff3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "public_black_24dp_1_",
  "data-name": "public_black_24dp (1)",
  transform: "translate(10.047 10.047)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_136",
  "data-name": "Path 136",
  d: "M0,0H21.905V21.905H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_137",
  "data-name": "Path 137",
  d: "M11.127,2a9.127,9.127,0,1,0,9.127,9.127A9.131,9.131,0,0,0,11.127,2Zm-.913,16.365a7.291,7.291,0,0,1-6.389-7.238,7.409,7.409,0,0,1,.192-1.634l4.372,4.372v.913A1.831,1.831,0,0,0,10.214,16.6Zm6.3-2.318a1.811,1.811,0,0,0-1.734-1.269h-.913V12.04a.915.915,0,0,0-.913-.913H7.476V9.3H9.3a.915.915,0,0,0,.913-.913V6.564H12.04a1.831,1.831,0,0,0,1.825-1.825V4.364a7.285,7.285,0,0,1,2.647,11.683Z",
  transform: "translate(-0.175 -0.175)",
  fill: "#f64000"
}));

var SvgGlobeInsideCircle = function SvgGlobeInsideCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_254",
    "data-name": "Group 254",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlobeInsideCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/globe-inside-circle.35cb3ad0.svg";
export { ForwardRef as ReactComponent };